import IconButtonMui, { IconButtonProps } from '@mui/material/IconButton';

export function IconButton(props: IconButtonProps) {
    return <IconButtonMui data-testid={'IconButton-container'} {...props} />;
}

export default IconButton;
